import React, {Suspense} from "react"
import {useSelector} from "react-redux"
import {Redirect, Route, Switch} from "react-router-dom"
import {Page404} from "scholastic-client-components/src/pages/ErrorPage/page404/Page404"
import {ReferrerSearchParams} from "scholastic-client-components/src/lib/routing"
import {AppPaths} from "./lib/routing"
import {AuthPage} from "./Pages/AuthPage/AuthPage"
import {ErrorBoundary} from "scholastic-client-components/src/features/ErrorBoundary"
import {BrowserUpdate} from "scholastic-client-components/src/features/BrowserUpdate/BrowserUpdate"
import {LoginWithSSO} from "./Pages/LoginWithSSO/LoginWithSSO"
import {SSOStatePage} from "./Pages/SSOStatePage/SSOStatePage"
import {SSOState} from "./features/SSO/types"
import {AlreadyConfirmedPage} from "./Pages/AlreadyConfirmedPage/AlreadyConfirmedPage"
const GuardedAccountPage = React.lazy(() => import("./Pages/AccountPage/AccountPage"))
const ConfirmAccountPage = React.lazy(() => import("./Pages/ConfirmAccountPage/ConfirmAccountPage"))
const GuardedNewlinePage = React.lazy(() => import("./Pages/DevicePage/DevicePage"))

const LazyGuardedAccountPage = () => (
    <Suspense fallback={null}>
        <GuardedAccountPage />
    </Suspense>
)

const LazyConfirmAccountPage = () => (
    <Suspense fallback={null}>
        <ConfirmAccountPage />
    </Suspense>
)

const LazyGuardedNewlinePage = () => (
    <Suspense fallback={null}>
        <GuardedNewlinePage />
    </Suspense>
)

export const App: React.FC = () => (
    <ErrorBoundary useSelector={useSelector}>
        <BrowserUpdate />
        <Switch>
            <Route path="/" exact>
                <Redirect to={`${AppPaths.Login}?${ReferrerSearchParams.URL}=/`} />
            </Route>
            <Route path={`${AppPaths.ResetPassword}/:token`} component={AuthPage} />

            <Route path={AppPaths.CreateNewlineUserAccount} component={LazyGuardedAccountPage} />
            <Route path={AppPaths.ConfirmNewlineUserAccount} component={LazyConfirmAccountPage} />
            <Route path={AppPaths.AlreadyConfirmed} component={AlreadyConfirmedPage} />
            <Route path={AppPaths.Device} component={LazyGuardedNewlinePage} />
            <Route path={AppPaths.Login} component={AuthPage} />
            <Route path={AppPaths.LoginSSO} component={LoginWithSSO} />
            <Route path={AppPaths.SSOSuccess}>
                <SSOStatePage state={SSOState.SUCCESS} />
            </Route>
            <Route path={AppPaths.SSOFailure}>
                <SSOStatePage state={SSOState.FAILURE} />
            </Route>
            <Route component={Page404} />
        </Switch>
    </ErrorBoundary>
)
